@use 'reset';

[data-player] {
  @include reset.nested-reset;
}
